import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import { getYesAndNoOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface ExpenseReasonSegmentedControlProps {
  name: string;
  id: string;
}

export function ExpenseReasonSegmentedControl({
  name,
  id,
}: ExpenseReasonSegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      id={id}
      control={control}
      width="100%"
      label={
        <CustomLabelWithTooltip
          labelText="Require expense reasons?"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              If you have additional questions about your expense reason, reach
              out to Client Relations.
            </Copy>
          }
        />
      }
      name={name}
      defaultValue="No"
      options={getYesAndNoOptions(id)}
    />
  );
}
